import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SmsTypeLookupComponent } from './sms-type-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [SmsTypeLookupComponent],
  exports: [SmsTypeLookupComponent],
  providers: []
})
export class SmsTypeLookupModule { }
